module.exports = __webpack_public_path__ + "img/redEnvelopedRainGameBackground.ae7d8b3b.png";